<template>
  <div>
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>UNIT</b-card-header>
          <b-card-body>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="TITEL"
            >
              <b-input 
                v-model="unit.Titel" 
                placeholder="Titel"
              />
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="REMOTE ID"
            >
              <b-input 
                v-model="unit.RemoteId" 
                disabled
              />
            </b-form-group>

            <b-form-group
              :label-cols-sm="labelColsSm"
              label="KENMERK"
              description="Bijvoorbeeld: Kantoorgebouw,School, etc."
            >
              <b-input
                v-model="unit.KenmerkObject"
                placeholder="Bijvoorbeeld: Kantoorgebouw,School, etc."
              />
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="LOCATIE VAN DE UNIT"
            >
              <b-input 
                v-model="unit.Locatievanobject" 
                placeholder="Locatie van de unit"
              />
            </b-form-group>

            <b-form-group label="ADRES">
              <b-input 
                v-model="unit.Adres" 
                placeholder="Adres van de unit"
              />
            </b-form-group>

            <b-form-row>
              <b-col :cols="labelColsSm">
                <b-form-group label="POSTCODE">
                  <b-input 
                    v-model="unit.Postcode" 
                    placeholder
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="PLAATS">
                  <b-input 
                    v-model="unit.WijkPlaats" 
                    placeholder
                  />
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="REGIO"
            >
              <b-input 
                v-model="unit.Regio" 
                placeholder
              />
            </b-form-group>
          </b-card-body>
        </b-card>

        <b-card no-body>
          <b-card-header>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="TYPE UNIT"
            >
              <b-input 
                v-model="unit.Type" 
                placeholder
              />
            </b-form-group>
          </b-card-header>
          <b-card-body>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="LEVERANCIER"
            >
              <b-input 
                v-model="unit.Leverancier" 
                placeholder
              />
            </b-form-group>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="FABRIEKS/INSTALL.nr."
            >
              <b-input 
                v-model="unit.Fabrieksnummer" 
                placeholder
              />
            </b-form-group>
            <b-form-row>
              <b-col :cols="labelColsSm">
                <b-form-group label="BOUWJAAR OFFSET">
                  <b-input 
                    v-model.number="unit.OffsetJaren" 
                    placeholder 
                    type="number"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="BOUWJAAR">
                  <b-input 
                    v-model.number="unit.Bouwjaar" 
                    :state="unit.Bouwjaar !== '' || unit.Bouwjaar !== null"
                    placeholder 
                    type="number"
                  />
                </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="INGEBRUIKNAME"
            >
              <DateInputField v-model="unit.Ingebruikname" />
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="MOD./REVISIE"
            >
              <b-input 
                v-model.number="unit.ModRevisieJaar" 
                placeholder 
                type="number"
              />
            </b-form-group>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="ALGEMENE CONDITIE"
            >
              <b-form-radio-group
                v-model="unit.AlgemeneConditie"
                :options="[ -2, { text: '-1', value: -1 },0,1,2,3,4,5,6,9]"
                size="sm"
                buttons
                button-variant="outline-secondary"
              />
            </b-form-group>
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-header>OVERIG</b-card-header>
          <b-card-body>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="ECO TECHNISCH"
            >
              <b-form-radio-group
                v-model="unit.EcoTechnisch"
                :options="ecotags"
                buttons
                button-variant="outline-secondary"
              />
            </b-form-group>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="ECO OMGEVING"
            >
              <b-form-radio-group
                v-model="unit.EcoOmgeving"
                :options="ecotags"
                buttons
                button-variant="outline-secondary"
              />
            </b-form-group>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="NORM"
            >
              <b-input
                v-model="unit.Norm"
              />
            </b-form-group>
            
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="BTW"
            >
              <b-form-radio-group
                v-model="unit.Btw"
                :options="[{text:'Geen',value:0},{text:'19%',value:1},{text:'21%',value:2}]"
                buttons
                button-variant="outline-secondary"
              />
            </b-form-group>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card no-body>
          <b-card-header>ONDERHOUD</b-card-header>
          <b-card-body>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="FIRMA"
            >
              <b-select
                v-model="unit.Onderhoudsfirma"
                :options="onderhoudsfirmas"
                text-field="Naam"
                value-field="Id"
              >
                <template #first>
                  <option 
                    value 
                    disabled
                  >
                    -- Kies een onderhoudsfirma --
                  </option>
                </template>
              </b-select>
            </b-form-group>
            <b-form-group
              :label-cols-sm="labelColsSm"
              label="SOORT ONDERHOUD"
            >
              <b-input 
                v-model="unit.Instellingen.soortOnderhoud" 
                placeholder
              />
            </b-form-group>
            <b-form-group
              :label-cols-sm="labelColsSm"
              label="ONDERHOUDSNUMMER"
              description="Het kenmerk van de onderhoudsfirma"
            >
              <b-input 
                v-model="unit.Onderhoudsnummer" 
                placeholder
              />
            </b-form-group>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="OH.CATEGORIE"
            >
              <b-form-radio-group
                v-model="unit.Onderhoudscategorie"
                :options="[ 
                  { text: 'Geen', value: 'Z' },
                  { text: 'A', value: 'A' },
                  { text: 'B', value: 'B' },
                  { text: 'C', value: 'C' }
                ]"
                buttons
                button-variant="outline-secondary"
              />
            </b-form-group>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="VEREISTE REACTIETIJD"
            >
              <b-input 
                v-model="unit.VereisteReactietijd" 
                placeholder
              />
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              :description="`standaard ${unit.Complex.Relatie.Config.standaardPreventief}`" 
              label="PREVENTIEF"
            >
              <b-input-group>
                <b-input 
                  v-model.number="unit.Instellingen.standaardPreventief" 
                  :placeholder="unit.Complex.Relatie.Config.standaardPreventief.toString()" 
                  min="0"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              :description="`standaard ${unit.Complex.Relatie.Config.standaardCorrectief}`" 
              label="CORRECTIEF"
            >
              <b-input-group>
                <b-input 
                  v-model.number="unit.Instellingen.standaardCorrectief" 
                  :placeholder="unit.Complex.Relatie.Config.standaardCorrectief.toString()"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              :description="`standaard ${unit.Complex.Relatie.Config.standaardKeuringskosten}`" 
              label="KEURINGSKOSTEN"
            >
              <b-input-group>
                <b-input 
                  v-model.number="unit.Instellingen.standaardKeuringskosten" 
                  :placeholder="unit.Complex.Relatie.Config.standaardKeuringskosten.toString()"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              :description="`standaard ${unit.Complex.Relatie.Config.standaardSpreekluister}`" 
              label="SPL"
            >
              <b-input-group>
                <b-input 
                  v-model.number="unit.Instellingen.standaardSpreekluister" 
                  :placeholder="unit.Complex.Relatie.Config.standaardSpreekluister.toString()"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              :description="`standaard ${unit.Complex.Relatie.Config.standaardAdvieskosten}`" 
              label="ADVIESKOSTEN"
            >
              <b-input-group>
                <b-input 
                  v-model.number="unit.Instellingen.standaardAdvieskosten" 
                  :placeholder="unit.Complex.Relatie.Config.standaardAdvieskosten.toString()"
                />
              </b-input-group>
            </b-form-group>

            <b-form-group 
              v-show="false" 
              label="IS CONDITIE NA"
            >
              <b-check v-model="unit.Instellingen.isConditieNa" />
            </b-form-group>
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-header>KEURINGEN</b-card-header>

          <b-card-body>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="INSTANTIE"
            >
              <b-select
                v-model="unit.Keuringsinstantie"
                :options="keuringsinstanties"
              >
                <template #first>
                  <option value="">Geen</option>
                </template>
              </b-select>
            </b-form-group>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="KEURINGSNUMMER"
            >
              <b-input 
                v-model="unit.Keuringsnummer" 
                placeholder
              />
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="KEURINGSDATUM"
            >
              <DateInputField v-model="unit.Keuringsdatum" />
            </b-form-group>
            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="KEURINGSSTATUS"
            >
              <b-select
                v-model="unit.KeuringsStatus"
                
                :options="[ 
                  { text: 'Goedgekeurd', value: 1 },
                  { text: 'Afgekeurd', value: 0 },
                  { text: 'Onbekend', value: -1 },
                  { text: 'NVT', value: -2 },
                ]"
              />
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              :disabled="unit.HuidigeStatus < 2" 
              label="KEURINGSALARM"
            >
              <b-check 
                v-model="unit.Keuringsalarm" 
                switch 
                value="1" 
                unchecked-value="0" 
                class="my-2"
              />
            </b-form-group>

            <b-form-group 
              :label-cols-sm="labelColsSm" 
              label="KEURINGSOPMERKING"
            >
              <b-list-group>
                <b-list-group-item 
                  v-for="(opm,index) in unit.Keuringsopmerkingen" 
                  :key="index"
                >
                  <b-badge 
                    variant="info"
                    pill 
                  >
                    {{ opm.type }}
                  </b-badge>
                  {{ opm.opmerking | truncate(30,'...') }}
                </b-list-group-item>
              </b-list-group>
              <small>Deze opmerkingen komen uit het laatste keuringsdocument.</small>
            </b-form-group>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <complex-bewerken 
              :complex="unit.Complex" 
              @save-complex="saveComplex" 
              @update-complex="unit.Complex = $event"
            />
            COMPLEX {{ unit.Complex.ComplexKenmerk }} 
          </b-card-header>
          <b-card-body>
            <b-card-text>
              <b-row>
                <b-col>
                  HUISMEESTER <br>
                  {{ unit.Complex.Huismeester }} <br>
                  <i class="fa fa-phone" /> {{ unit.Complex.Telefoon }}
                </b-col>
                <b-col>
                  RELATIE<br>
                  <b-link 
                    :to="{name: 'Relatie', params: {id: unit.Complex.Relatie.Id}}">{{ unit.Complex.Relatie.Naam }}</b-link>
                </b-col>
              </b-row>
            </b-card-text>

            <b-list-group>
              <b-list-group-item 
                v-for="u in unit.Complex.Units" 
                :key="u.Id" 
                :to="{name: 'UnitViewRoute',params: {id: u.Id}}" 
                :variant="u.Id == unit.Id ? 'primary' : 'secondary'"
              >
                {{ u.Kenmerk }} {{ u.Adres }} 
              </b-list-group-item>
            </b-list-group>
          </b-card-body>
        </b-card>

        <cloud-foto 
          :key="unit.Complex.Id"
          :url="'/complex/' + unit.Complex.Id + '/foto'"
          :public_id="unit.Complex.Id.toString()"
          title="COMPLEX FOTO"
          uploadfolder="/complex/"
        />
      </b-col>
    </b-row>

    <b-list-group v-show="false">
      <b-list-group-item 
        v-for="(key,i) in $props.unit" 
        :key="i"
      >
        {{ i }}: {{ key }}
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { serviceMixin } from "@/mixins/serviceMixin";
import CloudFoto from "@/components/CloudFoto";
import ComplexBewerken from "@/components/ComplexBewerken";
import DateInputField from '../../components/DateInputField.vue';

export default {
  components: {
    CloudFoto,
    ComplexBewerken,
    DateInputField
},
  mixins: [serviceMixin],
  props: {
    unit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      onderhoudsfirmas: [],
      labelColsSm: 4,
      relaties: [],
      ecotags: [
        { text: "Geen", value: "X" },
        { text: "A", value: "A" },
        { text: "B", value: "B" },
        { text: "C", value: "C" },
        { text: "D", value: "D" },
        { text: "E", value: "E" }
      ],
      fields: [
        {
          label: "Titel",
          field: "unit.Titel",
          description: "De titel van de unit"
        }
      ]
    };
  },
  computed: {
    ...mapGetters('relaties', ['keuringsinstanties']),
    complexUrl: function () {
      return `/complex/${this.unit.Complex.Id}/foto`
    },
    relatieOpties: function () {
      return this.relaties.map(function(item) {
        return {
        label: item.Naam,
        value: item.Id,
        }
      });
    },
  },
  mounted() {
    this.$store.dispatch('relaties/refreshIfStale');
    this.getOnderhoudsfirmas();
  },
  methods: {
    getOnderhoudsfirmas() {
      var vm = this;
      this.get("/onderhoud/relaties")
        .then(function(response) {
          console.dir(response.data);
          vm.onderhoudsfirmas = response.data.relaties;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    saveComplex() {
      var vm = this;
      this.put("/complex/" + this.unit.Complex.Id,{data:this.unit.Complex})
        .then(function(response) {
          console.dir(response.data);
          vm.unit.Complex = response.data.complex;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
  },
};
</script>